module.exports = __webpack_public_path__ + "img/krotoski-czestochowa.1d5227ad.jpg";